import { render, staticRenderFns } from "./edit-discount-table.vue?vue&type=template&id=6cf8189d&"
import script from "./edit-discount-table.vue?vue&type=script&lang=ts&"
export * from "./edit-discount-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports